import React from "react";
import Detail from "../../containers/Insurance_Certificate/Detail";

export default function Insurance_Detail() {
  return (
    <div>
      <Detail />
    </div>
  );
}
